import React from 'react';
import Tooltip from 'rc-tooltip';
import './styles.scss';
import ReactHtmlParser, { processNodes } from 'react-html-parser';

type Props = {
	data: Object,
	className: String,
	overlayExtraClass: String,
	onDefinitionAnchorClick?: () => void,
};

const buildOverlay = (message: string, onDefinitionAnchorClick?: () => void) => {
	if (onDefinitionAnchorClick) {
		const transform = (node, index) => {
			if (node.type !== 'tag' || !node.attribs) {
				return undefined;
			}
			const isPopupAnchor =
				node.name === 'a' && node.attribs['data-name'] === 'pop_Up';

			if (!isPopupAnchor) {
				return undefined;
			}

			const children = processNodes(node.children, transform);
			const triggerStyle = { color: 'lightblue', cursor: 'pointer' };
			const onTriggerClick = (e) => {
				e.preventDefault();
				onDefinitionAnchorClick();
			};

			return (
				<a
					key={index}
					href='#/'
					role='button'
					style={triggerStyle}
					onClick={onTriggerClick}>
					{children}
				</a>
			);
		};
		return <div>{ReactHtmlParser(message, { transform })}</div>;
	}
	return <div>{ReactHtmlParser(message)}</div>;
};

const CustomTooltip = ({ data, className, overlayExtraClass, onDefinitionAnchorClick }: Props) => {
	const Wrapper = data.inline ? 'span' : 'div';
	return (
	<Wrapper className={`tooltip-positioning ${data.inline ? 'inline-tooltip' : ''} ${data.extraClass} ${data.className} ${className}`}>
		<Tooltip
			placement='bottom'
			trigger={['click']}
			overlay={buildOverlay(data.message, onDefinitionAnchorClick)}
			overlayClassName={overlayExtraClass || ''}>
			<a
				href='#/'
				className={'tipicon'}
				data-tip={data.message}
				data-event='click focus'
				data-scroll-hide='false'
				tabIndex={-1}>
				<i>i</i>
			</a>
		</Tooltip>
	</Wrapper>
	);
};

CustomTooltip.defaultProps = {
	data: {
		message: 'default',
		className: '',
		extraClass: '',
	},
};

export default CustomTooltip;
